/** @format */

const template = `
<ng-form name="{{ctrl.name}}">
  <div class="form-group">
    <div class="row">
      <div class="col-md-6">
        <label for="{{ctrl.form.$name}}{{ctrl.name}}_min" ng-class="{'required': ctrl.minRequired}" translate
          >SIS_COMPONENTS.NUMBER.CREDIT_RANGE_EDITOR.MIN</label
        >

        <input
          data-cy="min-input"
          type="number"
          lang="fi"
          class="form-control string-input"
          name="min"
          min="{{ctrl.minMin}}"
          max="{{ctrl.minMax}}"
          ng-model="ctrl.ngModel.$viewValue.min"
          ng-change="ctrl.onChange()"
          ng-required="ctrl.minRequired" />
      </div>

      <div class="col-md-6">
        <label for="{{ctrl.form.$name}}{{ctrl.name}}_max" ng-class="{'required': ctrl.maxRequired}" translate
          >SIS_COMPONENTS.NUMBER.CREDIT_RANGE_EDITOR.MAX</label
        >
        <input
          data-cy="max-input"
          type="number"
          lang="fi"
          class="form-control string-input"
          name="max"
          min="{{ctrl.maxMin}}"
          max="{{ctrl.maxMax}}"
          ng-model="ctrl.ngModel.$viewValue.max"
          ng-change="ctrl.onChange()"
          ng-required="ctrl.maxRequired" />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <ul
          class="error-list"
          ng-if="ctrl.form[ctrl.name].min.$invalid"
          ng-messages="ctrl.form[ctrl.name].min.$error"
          ng-messages-multiple="true"
          role="alert">
          <li ng-message="min" translate translate-value-min="{{ ctrl.minMin }}"
            >SIS_COMPONENTS.NUMBER.CREDIT_RANGE_EDITOR.MIN_MUST_BE_MORE_THAN
          </li>
          <li ng-message="max" translate translate-value-max="{{ ctrl.minMax }}"
            >SIS_COMPONENTS.NUMBER.CREDIT_RANGE_EDITOR.MIN_MUST_BE_LESS_THAN
          </li>
          <li ng-message="required" translate>SIS_COMPONENTS.NUMBER.CREDIT_RANGE_EDITOR.MIN_REQUIRED </li>
        </ul>

        <ul
          class="error-list"
          ng-if="ctrl.form[ctrl.name].max.$invalid"
          ng-messages="ctrl.form[ctrl.name].max.$error"
          ng-messages-multiple="true"
          role="alert">
          <li ng-message="min" translate translate-value-min="{{ ctrl.maxMin }}"
            >SIS_COMPONENTS.NUMBER.CREDIT_RANGE_EDITOR.MAX_MUST_BE_MORE_THAN
          </li>
          <li ng-message="max" translate translate-value-max="{{ ctrl.maxMax }}"
            >SIS_COMPONENTS.NUMBER.CREDIT_RANGE_EDITOR.MAX_MUST_BE_LESS_THAN
          </li>
          <li ng-message="required" translate>SIS_COMPONENTS.NUMBER.CREDIT_RANGE_EDITOR.MAX_REQUIRED </li>
        </ul>

        <ul class="error-list" ng-if="ctrl.ngModel.$invalid" ng-messages="ctrl.ngModel.$error" ng-messages-multiple="true" role="alert">
          <li ng-message="minLowerThanOrEqualToMax" translate
            >SIS_COMPONENTS.NUMBER.CREDIT_RANGE_EDITOR.MIN_MUST_BE_LOWER_THAN_OR_EQUAL_TO_MAX
          </li>
        </ul>
      </div>
    </div>
  </div>
</ng-form>
`;
export default template;
